import styled, { keyframes } from "styled-components";
const shakeAnimation = keyframes`
  10%{
    transform: rotate(15deg);
  }
  20%{
    transform: rotate(-15deg);
  }
  30%{
    transform: rotate(15deg);
  }
  50%{
    transform: rotate(0deg);
  }
`;

export const Page = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0px 30px;
  justify-content: space-between;
  .greeting {
    text-transform: capitalize;
    font-size: 18px;
    span {
      font-weight: 600;
    }
  }
  .actions {
    display: flex;
    align-items: center;
    .action {
      margin-left: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 47px;
      height: 47px;
      border: 1px solid ${({ theme }) => theme.colors.secondary100};
      border-radius: 32px;
      transition: 0.6s;
      cursor: pointer;
      svg {
        width: 24px;
        height: 24px;
      }
      &:hover {
        background-color: ${({ theme }) => theme.colors.secondary100};
        svg {
          color: ${({ theme }) => theme.colors.secondary10};
        }
      }
    }
  }
  .active-shake-animation {
    animation: 1s ${shakeAnimation};
  }
`;
export const DropMenu = styled.div`
  border-radius: 8px;
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.secondary10};
  color: ${({ theme }) => theme.colors.secondary100};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  gap: 10px;
  padding: 5px 0px;
  margin-right: 30px;
  margin-top: 15px;
  li {
    cursor: pointer;
    text-align: center;
    width: 100%;
    transition: all 0.4s;
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.secondary10};
    }
  }
`;
export const DropMenuNotifications = styled.div`
  border-radius: 8px;
  width: 380px;
  height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.colors.secondary10};
  color: ${({ theme }) => theme.colors.secondary100};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  margin-right: 30px;
  margin-top: 15px;
  .notifications {
    flex: 80%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .notification {
      width: 100%;
      height: 100px;
      text-align: center;
      cursor: pointer;
      p {
        margin-top: 5px;
        font-size: 12px;
        align-self: center;
        color: ${({ theme }) => theme.colors.secondary70};
      }
      .notification-content {
        display: flex;
        align-items: center;
        padding-bottom: 10px;
        width: 95%;
        border-bottom: 1px solid  ${({ theme }) => theme.colors.secondary40};
        .icon {
          flex: 20%;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            width: 32px;
            height: 32px;
          }
        }
        .info{
          svg{
            color: ${({ theme }) => theme.colors.orange};
          }
        }
        .success{
          svg{
            color: ${({ theme }) => theme.colors.green};
          }
        }
        .error{
          svg{
            color: ${({ theme }) => theme.colors.red};
          }
        }
        .text {
          display: block;
          flex: 80%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
  p {
    flex: 10%;
    font-size: 16px;
    align-self: center;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
  }
`;
